import React from "react";

interface BankAccountIconProps {
  width?: number;
  height?: number;
  className?: string;
}

const BankAccountIcon: React.FC<BankAccountIconProps> = ({ width = 32, height = 32, className = "" }) => (
  <svg width={width} height={height} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
    <path d="M0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16Z" fill="#1E294F" />
    <path
      d="M22.6666 16.8321C22.6666 20.9987 19.7499 23.0821 16.2833 24.2904C16.1017 24.3519 15.9045 24.349 15.7249 24.2821C12.2499 23.0821 9.33325 20.9987 9.33325 16.8321V10.9987C9.33325 10.7777 9.42105 10.5658 9.57733 10.4095C9.73361 10.2532 9.94557 10.1654 10.1666 10.1654C11.8333 10.1654 13.9166 9.16541 15.3666 7.89875C15.5431 7.74791 15.7677 7.66504 15.9999 7.66504C16.2321 7.66504 16.4567 7.74791 16.6333 7.89875C18.0916 9.17375 20.1666 10.1654 21.8333 10.1654C22.0543 10.1654 22.2662 10.2532 22.4225 10.4095C22.5788 10.5658 22.6666 10.7777 22.6666 10.9987V16.8321Z"
      stroke="white"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default BankAccountIcon;
